var map = {
	"./ayupov.jpg": 5807,
	"./first-image.jpg": 9540,
	"./grigoryev.jpg": 4694,
	"./grinfeld.jpg": 7870,
	"./komus.svg": 9930,
	"./martynov.jpg": 3601,
	"./popov.jpg": 2410,
	"./second-image.jpg": 8305,
	"./sholokhov.jpg": 7338
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;